import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl } from "../utils/config";

import Loader from "./layouts/Loader";

function Notifications() {

    const navigate = useNavigate();
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState(globalState.state);
    
    async function onInit() {
        setLoading(true);

        try {
            const formData = new FormData();
            formData.append("type", "job");

            const response = await axios.post(
                baseUrl + "/api/notifications/fetch",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setNotifications(response.data.notifications);

                if (state.user != null) {
                    state.user.jobs_notifications = 0;

                    globalState.setState({
                        user: state.user
                    });
                }
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(function () {
        onInit();

        globalState.listen(function (newState, updatedState) {
            setState(newState);
        });
    }, []);

    return (
        <>
            <div className="container-xxl page-header bg-dark">
                <div className="container pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Notifications</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">Notifications</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Notifications</h1>
                    <div className="row g-4">
                        <div className="col-md-12">
                            <div className="wow fadeInUp" data-wow-delay="0.5s">

                                { loading && (
                                    <div className="text-center mb-3">
                                        <Loader />
                                    </div>
                                ) }

                                { notifications.map(function (n) {
                                    let href = "";
                                    if (["job_state_changed", "job_deleted", "new_job_application"].includes(n.type)) {
                                        href = "/jobs/" + n.table_id;
                                    } else if (n.type == "job_application_status_changed") {
                                        href = "/application/" + n.table_id;
                                    } else if (["employee_request", "employee_request_declined",
                                        "employee_request_accepted", "employee_request_removed"].includes(n.type)) {
                                        href = "/profile";
                                    }

                                    return (
                                        <div className="row mb-3" key={ `notification-${ n.id }` }>
                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h2>
                                                            <Link to={ href }>
                                                                { n.title }
                                                            </Link>
                                                        </h2>

                                                        <p>{ n.content }</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                }) }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Notifications;